/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';
import { CredentialFilter } from '../../../../types/CredentialFilter';
import { CredentialSort } from '../../../../types/CredentialSort';

export const CredentialSearchRequest: core.serialization.Schema<
    serializers.CredentialSearchRequest.Raw,
    Truvity.CredentialSearchRequest
> = core.serialization.object({
    filter: core.serialization.list(CredentialFilter).optional(),
    sort: core.serialization.list(CredentialSort).optional(),
});

export declare namespace CredentialSearchRequest {
    export interface Raw {
        filter?: CredentialFilter.Raw[] | null;
        sort?: CredentialSort.Raw[] | null;
    }
}
